import React from "react";

export const IconLabel = ({ icon, children, style }) => {
  return (
    <div style={{ ...style, ...styles.container }}>
      {icon}
      {children}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
};
